import React, { useEffect } from 'react';
import styles from './create-or-edit-position-category-modal.module.scss';
import { Col, Row } from 'antd';
import { DATE_TIME_FORMAT } from '../../../../../../utils/constants';
import { BasicDatePicker, BasicLabel, BasicSelect, BasicSwitch } from '../../../../../../assets/common';
import CustomAntModal from '../../../../../../components/CustomAntModal/CustomAntModal';
import { useFormik } from 'formik';
import moment from 'moment';

const criticalityStatus = [
  {
    value: 'Active',
    label: 'Active',
  },
  {
    label: 'Inactive',
    value: 'Inactive',
  },
];

const CreateOrEditPositionCategoryModal = ({
  open,
  setOpen,
  positionCategoryList,
  handleSubmitPositionCategory,
  positionCriticalityDetail,
  setPositionCriticalityDetail,
}) => {
  const isEdit = positionCriticalityDetail?.id ? true : false;

  const formik = useFormik({
    initialValues: {
      positionCategory: null,
      criticalityStatus: null,
      startDate: null,
      endDate: null,
      noEndDate: false,
    },
    enableReinitialize: true,
    onSubmit: (values) => {
      handleSubmitPositionCategory({ ...values }, positionCriticalityDetail?.id);
      formik.handleReset();
      setOpen(false);
    },
  });

  const handleChangeNoEndDate = (checked) => {
    if (!checked) {
      formik.setValues({
        noEndDate: formik.values.endDate,
        positionCategory: formik.values.positionCategory,
        criticalityStatus: formik.values.criticalityStatus,
        startDate: formik.values.startDate,
        endDate: null,
      });
    }
    formik.setFieldValue('noEndDate', checked);
  };

  useEffect(() => {
    if (isEdit) {
      formik.setValues({
        positionCategory: positionCriticalityDetail.position_category || null,
        criticalityStatus: positionCriticalityDetail.criticality_status || null,
        startDate: positionCriticalityDetail.start_date ? moment(positionCriticalityDetail.start_date) : null,
        endDate: positionCriticalityDetail.end_date ? moment(positionCriticalityDetail.end_date) : null,
        noEndDate: positionCriticalityDetail.end_date_toggle,
      });
    }
  }, []);

  return (
    <CustomAntModal
      open={open}
      setOpen={setOpen}
      title={isEdit ? 'Edit Position Category' : 'New Position Category'}
      onOk={formik.submitForm}
      onCancel={() => {
        formik.handleReset();
        setPositionCriticalityDetail({});
      }}
      okText={isEdit ? 'Save' : 'Add'}
      width={1000}
      destroyOnClose
    >
      <div className={styles.body}>
        <Row gutter={16}>
          <Col span={10} className={styles.customize}>
            <BasicLabel>Position Category</BasicLabel>
            <BasicSelect
              options={positionCategoryList}
              name="positionCategory"
              value={formik.values.positionCategory}
              onChange={(value) => formik.setFieldValue('positionCategory', value)}
              getPopupContainer={(trigger) => trigger}
              placeholder="Position Category"
            />
          </Col>
          <Col span={10} className={styles.customize}>
            <BasicLabel>Criticality Status</BasicLabel>
            <BasicSelect
              options={criticalityStatus}
              name="criticalityStatus"
              value={formik.values.criticalityStatus}
              onChange={(value) => formik.setFieldValue('criticalityStatus', value)}
              placeholder="Criticality Status"
              getPopupContainer={(trigger) => trigger}
            />
          </Col>
        </Row>
        <Row gutter={16} className="mb-6">
          <Col span={10} className={styles.customize}>
            <BasicLabel>Start Date</BasicLabel>
            <BasicDatePicker
              format={DATE_TIME_FORMAT.DATE_SLASH}
              placeholder="Start Date"
              getPopupContainer={(trigger) => trigger}
              name="startDate"
              value={formik.values.startDate}
              onChange={(value) => formik.setFieldValue('startDate', value)}
              disabledDate={(current) => (formik.values.endDate ? current > formik.values.endDate : false)}
            />
          </Col>

          {!formik.values.noEndDate && (
            <Col span={10} className={styles.customize}>
              <BasicLabel>End Date</BasicLabel>
              <BasicDatePicker
                format={DATE_TIME_FORMAT.DATE_SLASH}
                placeholder="End Date"
                getPopupContainer={(trigger) => trigger}
                name="endDate"
                value={formik.values.endDate}
                onChange={(value) => formik.setFieldValue('endDate', value)}
                disabledDate={(current) => current < formik.values.startDate}
              />
            </Col>
          )}
          <Col span={4} className={`${styles.customize} ${styles.switch_style}`}>
            <BasicSwitch name="noEndDate" checked={formik.values.noEndDate} onChange={(checked) => handleChangeNoEndDate(checked)} />
            <BasicLabel style={{ marginLeft: '8px' }}>No end date</BasicLabel>
          </Col>
        </Row>
      </div>
    </CustomAntModal>
  );
};

export default CreateOrEditPositionCategoryModal;
